"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums");

var utils_1 = require("../utils");

var FunctionConverter_1 = require("./FunctionConverter");

var NumberVariableConverter_1 = require("./NumberVariableConverter");

var TypedObjectBaseConverter_1 = require("./TypedObjectBaseConverter");

var ActionBaseConverter =
/** @class */
function (_super) {
  __extends(ActionBaseConverter, _super);

  function ActionBaseConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ActionBaseConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      selector: message.selector
    });
  };

  ActionBaseConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      selector: object.selector
    });
  };

  return ActionBaseConverter;
}(TypedObjectBaseConverter_1.TypedObjectBaseConverter);

exports.ActionBaseConverter = ActionBaseConverter;

var ExitFullscreenActionConverter =
/** @class */
function (_super) {
  __extends(ExitFullscreenActionConverter, _super);

  function ExitFullscreenActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ExitFullscreenActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  ExitFullscreenActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return ExitFullscreenActionConverter;
}(ActionBaseConverter);

exports.ExitFullscreenActionConverter = ExitFullscreenActionConverter;

var FunctionCallActionConverter =
/** @class */
function (_super) {
  __extends(FunctionCallActionConverter, _super);

  function FunctionCallActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FunctionCallActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      callOnParent: utils_1.withDefault(message.callOnParent, false),
      function: FunctionConverter_1.functionConverter.fromMessage(message.function)
    });
  };

  FunctionCallActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      callOnParent: object.callOnParent,
      function: FunctionConverter_1.functionConverter.toMessage(object.function)
    });
  };

  return FunctionCallActionConverter;
}(ActionBaseConverter);

exports.FunctionCallActionConverter = FunctionCallActionConverter;

var LoadSceneActionConverter =
/** @class */
function (_super) {
  __extends(LoadSceneActionConverter, _super);

  function LoadSceneActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LoadSceneActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      autoPlay: utils_1.withDefault(message.autoPlay, true),
      sceneId: message.sceneId
    });
  };

  LoadSceneActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      autoPlay: object.autoPlay,
      sceneId: object.sceneId
    });
  };

  return LoadSceneActionConverter;
}(ActionBaseConverter);

exports.LoadSceneActionConverter = LoadSceneActionConverter;

var PauseActionConverter =
/** @class */
function (_super) {
  __extends(PauseActionConverter, _super);

  function PauseActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PauseActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  PauseActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return PauseActionConverter;
}(ActionBaseConverter);

exports.PauseActionConverter = PauseActionConverter;

var PlayActionConverter =
/** @class */
function (_super) {
  __extends(PlayActionConverter, _super);

  function PlayActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PlayActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  PlayActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return PlayActionConverter;
}(ActionBaseConverter);

exports.PlayActionConverter = PlayActionConverter;

var RequestFullscreenActionConverter =
/** @class */
function (_super) {
  __extends(RequestFullscreenActionConverter, _super);

  function RequestFullscreenActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RequestFullscreenActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  RequestFullscreenActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return RequestFullscreenActionConverter;
}(ActionBaseConverter);

exports.RequestFullscreenActionConverter = RequestFullscreenActionConverter;

var SeekActionConverter =
/** @class */
function (_super) {
  __extends(SeekActionConverter, _super);

  function SeekActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SeekActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      time: NumberVariableConverter_1.numberVariableConverter.fromMessage(message.time)
    });
  };

  SeekActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      time: NumberVariableConverter_1.numberVariableConverter.toMessage(object.time)
    });
  };

  return SeekActionConverter;
}(ActionBaseConverter);

exports.SeekActionConverter = SeekActionConverter;

var TagActionConverter =
/** @class */
function (_super) {
  __extends(TagActionConverter, _super);

  function TagActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TagActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message), {
      tag: message.tag,
      subAction: message.subAction
    });
  };

  TagActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object), {
      tag: object.tag,
      subAction: object.subAction
    });
  };

  return TagActionConverter;
}(ActionBaseConverter);

exports.TagActionConverter = TagActionConverter;

var ThumbsDownActionConverter =
/** @class */
function (_super) {
  __extends(ThumbsDownActionConverter, _super);

  function ThumbsDownActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ThumbsDownActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  ThumbsDownActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return ThumbsDownActionConverter;
}(ActionBaseConverter);

exports.ThumbsDownActionConverter = ThumbsDownActionConverter;

var ThumbsUpActionConverter =
/** @class */
function (_super) {
  __extends(ThumbsUpActionConverter, _super);

  function ThumbsUpActionConverter() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ThumbsUpActionConverter.prototype.fromMessage = function (message) {
    return __assign({}, _super.prototype.fromMessage.call(this, message));
  };

  ThumbsUpActionConverter.prototype.toMessage = function (object) {
    return __assign({}, _super.prototype.toMessage.call(this, object));
  };

  return ThumbsUpActionConverter;
}(ActionBaseConverter);

exports.ThumbsUpActionConverter = ThumbsUpActionConverter;
exports.exitFullscreenActionConverter = new ExitFullscreenActionConverter();
exports.functionCallActionConverter = new FunctionCallActionConverter();
exports.loadSceneActionConverter = new LoadSceneActionConverter();
exports.pauseActionConverter = new PauseActionConverter();
exports.playActionConverter = new PlayActionConverter();
exports.requestFullscreenActionConverter = new RequestFullscreenActionConverter();
exports.seekActionConverter = new SeekActionConverter();
exports.tagActionConverter = new TagActionConverter();
exports.thumbsDownActionConverter = new ThumbsDownActionConverter();
exports.thumbsUpActionConverter = new ThumbsUpActionConverter();

var ActionConverter =
/** @class */
function () {
  function ActionConverter() {}

  ActionConverter.prototype.fromMessage = function (message) {
    switch (message.type) {
      case enums_1.ActionType.ExitFullscreen:
        return exports.exitFullscreenActionConverter.fromMessage(message);

      case enums_1.ActionType.FunctionCall:
        return exports.functionCallActionConverter.fromMessage(message);

      case enums_1.ActionType.LoadScene:
        return exports.loadSceneActionConverter.fromMessage(message);

      case enums_1.ActionType.Pause:
        return exports.pauseActionConverter.fromMessage(message);

      case enums_1.ActionType.Play:
        return exports.playActionConverter.fromMessage(message);

      case enums_1.ActionType.RequestFullscreen:
        return exports.requestFullscreenActionConverter.fromMessage(message);

      case enums_1.ActionType.Seek:
        return exports.seekActionConverter.fromMessage(message);

      case enums_1.ActionType.Tag:
        return exports.tagActionConverter.fromMessage(message);

      case enums_1.ActionType.ThumbsDown:
        return exports.thumbsDownActionConverter.fromMessage(message);

      case enums_1.ActionType.ThumbsUp:
        return exports.thumbsUpActionConverter.fromMessage(message);
    }
  };

  ActionConverter.prototype.toMessage = function (object) {
    switch (object.type) {
      case enums_1.ActionType.ExitFullscreen:
        return exports.exitFullscreenActionConverter.toMessage(object);

      case enums_1.ActionType.FunctionCall:
        return exports.functionCallActionConverter.toMessage(object);

      case enums_1.ActionType.LoadScene:
        return exports.loadSceneActionConverter.toMessage(object);

      case enums_1.ActionType.Pause:
        return exports.pauseActionConverter.toMessage(object);

      case enums_1.ActionType.Play:
        return exports.playActionConverter.toMessage(object);

      case enums_1.ActionType.RequestFullscreen:
        return exports.requestFullscreenActionConverter.toMessage(object);

      case enums_1.ActionType.Seek:
        return exports.seekActionConverter.toMessage(object);

      case enums_1.ActionType.Tag:
        return exports.tagActionConverter.toMessage(object);

      case enums_1.ActionType.ThumbsDown:
        return exports.thumbsDownActionConverter.toMessage(object);

      case enums_1.ActionType.ThumbsUp:
        return exports.thumbsUpActionConverter.toMessage(object);
    }
  };

  return ActionConverter;
}();

exports.ActionConverter = ActionConverter;
exports.actionConverter = new ActionConverter();